import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { isVideo } from "@/lib/constants";

export default function CarouselViewer({ slides, title, testid = "carousel" }) {
  const [idx, setIdx] = useState(0);
  const list = (slides || []).filter(Boolean);
  if (list.length === 0) return null;
  const cur = Math.min(idx, list.length - 1);
  return (
    <div className="relative w-full" data-testid={testid}>
      {isVideo(list[cur]) ? (
        <video src={list[cur]} controls playsInline className="w-full aspect-[9/16] object-contain bg-black" data-testid={`${testid}-slide-video`} />
      ) : (
        <img src={list[cur]} alt={`${title} — visuel ${cur + 1}`} className="w-full aspect-[4/5] object-cover" data-testid={`${testid}-slide`} />
      )}
      {list.length > 1 && (
        <>
          <button
            data-testid={`${testid}-prev`}
            onClick={(e) => { e.stopPropagation(); setIdx((cur - 1 + list.length) % list.length); }}
            className="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-black/50 text-white flex items-center justify-center hover:bg-black/70 transition-colors"
            aria-label="Visuel précédent"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <button
            data-testid={`${testid}-next`}
            onClick={(e) => { e.stopPropagation(); setIdx((cur + 1) % list.length); }}
            className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-black/50 text-white flex items-center justify-center hover:bg-black/70 transition-colors"
            aria-label="Visuel suivant"
          >
            <ChevronRight className="w-5 h-5" />
          </button>
          <span data-testid={`${testid}-counter`}
            className="absolute bottom-2 right-2 bg-black/60 text-white text-[10px] font-medium rounded-full px-2 py-0.5">
            {cur + 1}/{list.length}
          </span>
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1">
            {list.map((_, i) => (
              <span key={i} className={`w-1.5 h-1.5 rounded-full transition-colors ${i === cur ? "bg-white" : "bg-white/40"}`} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
